import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaFacebookF, FaYoutube, FaEnvelope } from "react-icons/fa";
import "../styles/Footer.css";

function Footer() {
  return (
    <footer className="footer bg-light text-dark mt-5 pt-4 pb-3">
      <Container>
        <Row className="gy-4">
          {/* Cột 1: Thương hiệu + Giới thiệu Kids Learn */}
          <Col
            md={4}
            className="d-flex flex-column align-items-start"
          >
            <img
              src="/logo.webp"
              alt="Design24 Logo"
              className="footer__logo"
              width={120} // hoặc tùy chỉnh
              height="auto"
            />
            <h5 className="footer__title mt-3">Kids Learn by Design24</h5>
            <p className="footer__desc">
              Nền tảng học Mỹ thuật và Lập trình cho thiếu nhi do Design24 phát
              triển. Giúp trẻ phát triển tư duy sáng tạo, kỹ năng công nghệ và
              thẩm mỹ từ sớm.
            </p>
            <p className="footer__brand-small mt-3">
              <strong>Design24</strong> – Phát triển sản phẩm công nghệ, giáo
              dục và thiết kế vì cộng đồng.
            </p>
          </Col>

          {/* Cột 2: Liên hệ doanh nghiệp */}
          <Col md={4}>
            <h6 className="footer__subtitle">Thông tin công ty</h6>
            <ul className="footer__contacts list-unstyled">
              <li>MST: 1801676144</li>
              <li>Thành lập: 20/07/2020</li>
              <li>
                ĐT: <a href="tel:0704888009">0704.888.009</a> -{" "}
                <a href="tel:0784888009">0784.888.009</a>
              </li>
              <li>Email: Design24.vn@gmail.com</li>
              <li>TP.HCM: 302A Nguyễn Thượng Hiền, Q. Phú Nhuận</li>
              <li>Cần Thơ: 661F/29, KV. Bình Yên A, Q. Bình Thủy</li>
              <li>
                Fanpage:{" "}
                <a
                  href="https://www.facebook.com/www.design24.edu.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Học viện Design24
                </a>
              </li>
            </ul>
          </Col>

          {/* Cột 3: Liên kết & Mạng xã hội */}
          <Col md={4}>
            <h6 className="footer__subtitle">Liên kết nhanh</h6>
            <ul className="footer__links list-unstyled">
              <li>
                <Link
                  to="/art"
                  className="footer__link"
                >
                  Khóa học Mỹ thuật
                </Link>
              </li>
              <li>
                <Link
                  to="/code"
                  className="footer__link"
                >
                  Khóa học Lập trình
                </Link>
              </li>
              <li>
                <a
                  href="https://design24.edu.vn/gioi-thieu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__link"
                >
                  Về chúng tôi
                </a>
              </li>
            </ul>

            <h6 className="footer__subtitle mt-4">Kết nối</h6>
            <div className="footer__social d-flex gap-3">
              <a
                href="https://www.facebook.com/www.design24.edu.vn"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.youtube.com/@design2424"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>
              <a
                href="mailto:Design24.vn@gmail.com"
                aria-label="Email"
              >
                <FaEnvelope />
              </a>
            </div>
          </Col>
        </Row>

        <hr className="my-4" />

        <div className="text-center small text-muted">
          © {new Date().getFullYear()} Design24. All rights reserved.
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
